//React
import { FunctionComponent } from "react";

//Google Maps
import { APIProvider } from "@vis.gl/react-google-maps";
import DrhGoogleMap from "./google-map";

//App Hooks
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectIsMobile } from "../../../system/redux/selectors/select-is-mobile";
import { selectIsAnchorClicked } from "../../../system/redux/selectors/select-is-anchor-clicked";

//Components
import FacetContainer from "../../../facets/components/facet-sort-container";

interface MapProps {}

export const DrhMapWrapper: FunctionComponent<MapProps> = (props) => {
	const isMobile = useAppSelector(selectIsMobile);
	const isAnchorClicked = useAppSelector(selectIsAnchorClicked);
	const mobileStyling = {
		display: isAnchorClicked ? 'none' : 'block'
	};

	return (
		<>
			<APIProvider apiKey={process.env.REACT_APP_DRH_MAP_API_KEY}>
				{isMobile && <FacetContainer />}

				<div className={isMobile ? "mobileMap" : "desktopMap"} style={mobileStyling}>
					<div
						className="area community-results__map js-area-map"
						style={{ overflow: "visible" }}
					>
						<DrhGoogleMap />
					</div>
				</div>
			</APIProvider>
		</>
	);
};

export default DrhMapWrapper;
